import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { formatAmount } from "@utils/formatPrice";
import type { Stripe } from "@stripe/stripe-js";

export function Payment() {
  const { t } = useTranslation();
  const location = useLocation();

  const paymentData = location.state.paymentData;
  const amountDetails = location.state.amountDetails;

  const [clientSecret] = useState<string | null>(
    paymentData.clientSecret ?? null,
  );
  const [stripePromise] = useState<Promise<Stripe | null> | null>(() =>
    loadStripe(paymentData.stripePublicKey),
  );

  if (!clientSecret || !stripePromise) {
    return <p>Chargement du paiement...</p>;
  }

  return (
    <div className="flex flex-col gap-12 mb-16">
      <div className="text-[24px] lg:text-[32px] font-bold font-jakarta text-text-strong">
        {t("confirmation.confirmBooking")}
      </div>
      <div className="block-section flex flex-col gap-4">
        <div className="flex flex-col gap-4 mt-6 text-text-strong">
          <div className="flex text-base font-bold lg:text-[24px] font-jakarta justify-between">
            {t("cart.totalTravel")} :{" "}
            <span>
              {amountDetails && formatAmount(amountDetails.outOfPocketAmount)}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <p className="flex text-sm lg:text-[20px] font-jakarta justify-between">
              {t("cart.initialPrice")} :{" "}
              <span>
                {amountDetails &&
                  formatAmount(amountDetails.includedTaxesTotalAmount)}
              </span>
            </p>
            <p className="flex text-sm lg:text-[20px] font-jakarta justify-between">
              {t("cart.coveredAmount")}
              <span>
                {amountDetails && formatAmount(amountDetails.coveredAmount)}
              </span>
            </p>
            <p className="flex text-sm lg:text-[20px] font-jakarta justify-between">
              {t("cart.agencyFees")} :{" "}
              <span>
                {amountDetails && formatAmount(amountDetails.agencyFees)}
              </span>
            </p>
          </div>
        </div>

        <div className="w-full ">
          {stripePromise && clientSecret && (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{ clientSecret }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </div>
    </div>
  );
}
